// Filtre linkleri mevcut query'yi korur — ?cat seçince ?renk silinmez.
export type FilterParams = {
  q?: string;
  cat?: string;
  renk?: string;
  stil?: string;
  sort?: string;
  min?: string;
  max?: string;
  badge?: string;
  page?: string;
  indirim?: string;
};

export function buildFilterUrl(
  base: FilterParams,
  overrides: Partial<FilterParams & { clear?: boolean }>,
  basePath: string = "/urunler"
): string {
  if (overrides.clear) return basePath;
  const merged: Record<string, string> = {};
  for (const [k, v] of Object.entries({ ...base, ...overrides })) {
    if (k === "clear") continue;
    if (v !== undefined && v !== "") merged[k] = String(v);
  }
  // page değişmeyen filtrede sıfırlanır (override yoksa 1. sayfaya dön)
  if (!("page" in overrides) && Object.keys(overrides).length > 0) {
    delete merged.page;
  }
  const qs = new URLSearchParams(merged).toString();
  return qs ? `${basePath}?${qs}` : basePath;
}

export function removeFilterKey(base: FilterParams, key: keyof FilterParams, basePath: string = "/urunler"): string {
  const copy = { ...base };
  delete copy[key];
  delete copy.page;
  const qs = new URLSearchParams(copy as Record<string, string>).toString();
  return qs ? `${basePath}?${qs}` : basePath;
}

/** Arama sayfası URL'si — tüm arama submit'leri buraya gider: /arama?q=... */
export function buildSearchUrl(term: string, extra?: Partial<FilterParams>): string {
  const t = term.trim().slice(0, 100);
  const qs = new URLSearchParams({ ...(extra as Record<string, string> ?? {}), ...(t ? { q: t } : {}) }).toString();
  return qs ? `/arama?${qs}` : "/arama";
}
